// extracted by mini-css-extract-plugin
export var formContainer = "_kt-0";
export var message = "_kt-1";